import React, { useEffect, useRef, useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Icon,
  useMediaQuery,
} from '@material-ui/core'
import CancelButton from 'app/components/buttons/CancelButton'
import clsx from 'clsx'
import useMobileStyle from 'app/components/mobileModal/mobileModalStyle'
import PrimaryButton from '../../../components/buttons/PrimaryButton'
import Formsy from 'formsy-react'
import { useFormsy } from 'commons/form'
import { TextFieldFormsy } from '@fuse'
import effects from '../../../effects/effects'
import { useDispatch } from 'react-redux'
import MessageAlert from '../../../components/MessageAlert'
import { FormattedMessage, useIntl } from 'react-intl'
import * as R from 'ramda'
import { useFlag } from '@unleash/proxy-client-react'

export default (props) => {
  const {
    alias,
    state,
    classes,
    toggleDialogs,
    LANDING_DIALOG,
    onCreateLanding,
    onCancel,
    landingUrl,
    isFirstTime,
    onSetFirstTime,
  } = props
  const mes_657_error_message_when_use_duplicate_name = useFlag(
    'mes_657_error_message_when_use_duplicate_name',
  )
  const mobileClasses = useMobileStyle()
  const { formatMessage } = useIntl()
  const formRef = useRef()
  const [landingElemSize, setLandinElemWidth] = useState(null)
  const [isFormValid, setIsFormValid] = useState(false)
  const [generatedAlias, setGeneratedAlias] = useState('')
  const dispatch = useDispatch()
  const matches = useMediaQuery('(min-width:800px)')
  const [nonSupportedSymbol, setnonSupportedSymbol] = useState(true)

  const { isPristine, onChange } = useFormsy(
    formRef,
    (pristineValue, currentValue) => {
      return R.equals(pristineValue, currentValue)
    },
  )

  const isValid = isPristine || !isFormValid
  const isDisable = isFirstTime ? !isFormValid : isValid

  const handleSubmit = async (model) => {
    try {
      if (mes_657_error_message_when_use_duplicate_name) {
        isFirstTime && onSetFirstTime()
      }
      await effects.apis.putUniqueName(model)
      onCreateLanding(model.uniqueName)
      toggleDialogs(LANDING_DIALOG, false)
    } catch (e) {
      const errorCode = e.response.data.details.code
      if (errorCode === 814) {
        dispatch(
          MessageAlert.showError({
            message: formatMessage({
              id: 'profile.info.alias.error',
            }),
          }),
        )
      }
    }
  }

  const generateLandingUrl = async () => {
    const { alias } = await effects.apis.getGenerateLandingUrl()
    setGeneratedAlias(alias)
  }

  const landingPageNameonChange = (text) => {
    const regex = /^[a-zA-Z0-9-_]*$/
    const symbolsChar = regex.test(text)
    setnonSupportedSymbol(symbolsChar)
    setIsFormValid(symbolsChar)
  }
  useEffect(() => {
    if (!alias) {
      generateLandingUrl()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setGeneratedAlias('')
  }, [alias])

  useEffect(() => {
    state.isOpenLandingDialog &&
      landingPageNameonChange(generatedAlias || alias)
  }, [state, alias, generatedAlias])

  return (
    <Dialog
      open={state.isOpenLandingDialog}
      className={clsx(
        classes.createLandingDialog,
        mobileClasses.lessPaddingMobile,
      )}
    >
      <Formsy
        onValidSubmit={handleSubmit}
        onChange={onChange}
        ref={formRef}
        className="flex flex-col overflow-hidden"
      >
        <DialogTitle
          id="alert-dialog-title"
          className={classes.groupDeleteTitle}
        >
          <FormattedMessage id="profile.info.choose" />
        </DialogTitle>
        <DialogContent>
          <div className="flex relative">
            <div className="min-w-48 pt-20">
              <Icon color="action">language</Icon>
            </div>
            {matches && (
              <div
                className={classes.landingPrefix}
                ref={(el) => {
                  setLandinElemWidth(el ? el.clientWidth + 15 : 0)
                }}
              >
                {landingUrl}
              </div>
            )}
            <TextFieldFormsy
              className="mb-24"
              value={generatedAlias || alias}
              name="uniqueName"
              variant="outlined"
              inputProps={{
                'data-testid': 'profileEditContactUrl',
                style: {
                  paddingLeft: landingElemSize,
                },
              }}
              fullWidth
              onChange={(e) => landingPageNameonChange(e.target.value)}
            />
          </div>

          <div className={mobileClasses.modalparagraph}>
            {!nonSupportedSymbol && (
              <FormattedMessage id="non.supported.symbols.text" />
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <CancelButton
            onClick={() => {
              toggleDialogs(LANDING_DIALOG, false)
              onCancel()
            }}
            className={mobileClasses.modalBtn}
          />
          <PrimaryButton
            type="submit"
            aria-label="save"
            isLoading={!state.isOpenLandingDialog}
            disabled={isDisable}
            labelId="action.ok"
          />
        </DialogActions>
      </Formsy>
    </Dialog>
  )
}
